import apiConfig from '../config/api';
import { SessionStorageService } from './index';

/**
 * Servicio para escuchar el progreso de carga de archivos mediante Server-Sent Events (SSE)
 */
class UploadProgressService {

    /**
     * Escucha el progreso de una carga de archivo
     * @param {string} uploadId - batchId/upload
     * @param {function} onProgress - Callback cuando hay progreso: (progress, processName) => void
     * @param {function} onComplete - Callback cuando se completa: (results, errors) => void
     * @param {function} onError - Callback opcional para errores: (error) => void
     * @returns {function} Función de cleanup para cerrar la conexión SSE
     */
    static listenProgress(uploadId, { onProgress, onComplete, onError = null, onInactivity = () => {} }) {
        const authToken = SessionStorageService.read('authToken');

        let lastSeen = Date.now();
        let inactive = false;
        let closed = false;
        let watchdog = null;
        const inactivityMs = 60000; // 60 segundos
        

        const eventSource = new EventSource(
            `${apiConfig.url}/progress/${uploadId}?token=${authToken}`,
            { withCredentials: true }
        );

        const close = () => {
            try {
                if (closed) return;
                closed = true;
                if (watchdog) clearInterval(watchdog);
                eventSource.close();
            } catch (e) {
                console.error('Error al cerrar SSE:', e);
            }
        };

        eventSource.onopen = () => {
            lastSeen = Date.now();
            inactive = false;
        };

        // heartbeat
        eventSource.addEventListener("ping", () => {
            lastSeen = Date.now();
            inactive = false;
        });

        eventSource.addEventListener('progress', (event) => {
            lastSeen = Date.now();
            inactive = false;
            const progressData = JSON.parse(event.data);

            if (progressData.status === 'ERROR') {
                if (onError) onError(progressData);
                close();
                return;
            }

            if (progressData.finished === true) {
                onComplete(progressData);
                close();
            }else {
                onProgress(progressData);
            }
        });

        // LÓGICA DE DESCONEXIÓN
        eventSource.onerror = (err) => {
            console.error("SSE error", err);
            if (!closed) {
                onError("messages.aml.connectionLost");
                close();
            }
        };

        // watchdog de inactividad
        watchdog = setInterval(() => {
            const silence = Date.now() - lastSeen;

            if (!closed && !inactive && silence > inactivityMs) {
                inactive = true;
                onInactivity();
            }
        }, 5000);

        return { close };
    }
}

export default UploadProgressService;
